import moment from 'moment-timezone';

export default function formatToGMT(date) {
	return moment(date).clone().tz('GMT').format();
}
